import axios from 'axios';
import {includes, some} from 'lodash';

import {STATUS_CODES} from 'constants/http';
import {LogoutType} from 'enums';
import {userAuthUtils} from 'utils';

const NO_RETRY_URLS = [
    '/api/actions/client',
    '/api/auth/refresh-token',
    '/api/session/session-access-token',
    '/api/auth/logout',
    'api/auth/external/auth-token'
];

export const configure = () => {
    axios.interceptors.response.use((config) => config,
        (error) => {
            const statusCode = error?.response?.status;
            const originalRequest = error.config;
            const isUrl = (url: string) => includes(error?.response?.config?.url, url);
            const isRefreshTokenUrl = isUrl('/api/auth/refresh-token');
            const isNoRetryUrl = some(NO_RETRY_URLS, (url) => isUrl(url));
            if (statusCode === STATUS_CODES.UNAUTHORIZED && !isNoRetryUrl && !originalRequest._retry) {
                originalRequest._retry = true;
                return userAuthUtils.refreshAccessToken().then(() => axios(originalRequest));
            }
            if (isRefreshTokenUrl) {
                userAuthUtils.logout(LogoutType.TokenExpired);
            }
            return Promise.reject(error);
        },
    );

    axios.interceptors.request.use(async (config) => {
        if (!includes(config.url, '/api/actions/client')) {
            if (!includes(config.url, '/api/auth/refresh-token') && userAuthUtils.accessTokenExpiresSoon()) {
                await userAuthUtils.refreshAccessToken();
            }
            const accessToken = userAuthUtils.getAccessToken();
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
        }
        return config;
    });
};
